import { SortDirection } from '@vueling-ng/vy-ds/src/lib/components/globals/table';

export interface Filters {
  status?: string;
  departureCode?: string;
  returnCode?: string;
  departureDate?: string;
  returnDate?: string;
  channelType?: string;
  recordLocator?: string;
  firstName?: string;
  lastName?: string;
}

export interface BookingsRequest {
  organizationCode: string;
  pageSize?: string;
  page?: string;
  orderField?: string;
  order?: string;
  filters?: Filters;
}

export interface Booking {
  recordLocator: string;
  origin: string;
  destination: string;
  departureDate: Date;
  returnDate: Date;
  passengerCount: number;
  status: StatusBookings;
  gdsRecordLocator?: string;
  channelType?: ChannelTypeOptions;
  amount?: number;
  currency?: string;
  availableCredit?: number;
  usedCredit?: number;
}

export interface BookingsResponse {
  totalPages: number;
  pageSize: number;
  page: number;
  orderField?: string;
  order?: string;
  bookings: Booking[];
  bookingsFlightCredit?: Booking[];
  totalRequest: number;
}

export interface BookingsParams {
  pageNumber: number;
  pageSize?: number;
  sortCriteria?: SortCriteria;
  filters?: Filters;
}

export type ChannelTypeOptions = 'GDS' | 'TTOO' | 'B2B';

export const ChannelType: Record<ChannelTypeOptions, string> = {
  GDS: 'GDS',
  TTOO: 'TTOO',
  B2B: 'B2B'
};

export interface SortCriteria {
  column: SortColumn;
  direction: SortDirection;
}

export type SortColumn =
  | 'None'
  | 'RecordLocator'
  | 'Origin'
  | 'Destination'
  | 'DepartureDate'
  | 'ReturnDate'
  | 'PassengerCount'
  | 'Status'
  | 'Available'
  | 'Used'
  | 'Amount'
  | 'AvailableCredit'
  | 'UsedCredit';

export const defaultSortCriteria: SortCriteria = {
  column: 'None',
  direction: 'desc'
};

export type StatusBookings =
  | 'PendingPayment'
  | 'PendingFlight'
  | 'PendingProcess'
  | 'PendingRefund'
  | 'Flown'
  | 'Cancelled'
  | 'Available'
  | 'Used'
  | 'All';

export const TypeStatusBookings: Record<StatusBookings, string> = {
  PendingFlight: 'PendingFlight',
  PendingProcess: 'PendingProcess',
  PendingPayment: 'PendingPayment',
  PendingRefund: 'PendingRefund',
  Flown: 'Flown',
  Cancelled: 'Cancelled',
  Available: 'Available',
  Used: 'Used',
  All: 'All'
};

export const defaultPageSize = 10;

export const CifRegex = /<CIF>(.*?)<\/CIF>/;

export const EmptyBookingsResponse: BookingsResponse = {
  bookings: [],
  page: 0,
  pageSize: 0,
  totalPages: 0,
  totalRequest: 0,
  order: '',
  orderField: ''
};
